import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const ImageWithBanner = ({ children, className, ...props }) => {
  const [image] = React.Children.toArray(children);

  return (
    <div className={cx(className)} {...props}>
      {image}
    </div>
  );
};
ImageWithBanner.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default ImageWithBanner;
